import { useLazyQuery, useMutation } from '@apollo/client';
import { Box } from '@material-ui/core';
import { TitlePage } from 'component/customize_style_component/styled_title';
import CustomizeLayoutQuiz from 'component/layout_quiz/layout_quiz';
import { useAuth } from 'contexts/AuthContext';
import { CREATE_ANSWER } from 'graph_ql/getQuiz/mutation';
import { GET_QUESTION_DATA, GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { GET_USER_BY_USERNAME } from 'graph_ql/users/queries';
import _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import themes from 'styles/themes';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getSizeQuizId } from 'utils/utils';
import { useGetGender } from '../../../hooks/useGetGender';
import { PATH } from '../../../routes/constant';
import Picker from 'component/ios_picker/iosPicker';
import { useStyles } from './styles';
import { Spinner } from 'react-bootstrap';
import { MultipleiOSPicker } from 'component/ios_picker/iosMultiplePicker';
import { EGENDER, quizContextType } from 'types/quiz';
import { EQuizOrder } from '../setup_quiz';
import { STRINGS } from '../../../constants/strings';
const MultipleColumnQuestion = ['question_sizes_female_bra'];

const generateQuestionSizeListOptions = (question, listQuestionDatas) => {
    question.listOptions = listQuestionDatas
        .filter((questionData) => questionData.tags.includes('female_bra_number'))
        .map((item) => {
            return { label: item.title, value: item.value, id: item.id };
        });

    question.listSecondOptions = listQuestionDatas
        .filter((questionData) => questionData.tags.includes('female_bra_size'))
        .map((item) => {
            return { label: item.title, value: item.value, id: item.id };
        });

    return question;
};

const mapQuestionDataToQuestions = (listQuestions, listQuestionDatas, questionIndex) => {
    const listDataSizes = listQuestions.map((item, index) => {
        if (index === questionIndex) {
            if (MultipleColumnQuestion.includes(item.id)) {
                item = generateQuestionSizeListOptions(item, listQuestionDatas);
            } else {
                item.listOptions = listQuestionDatas.map((item) => {
                    return { label: item.title, value: item.value, id: item.id };
                });
            }
            return { ...item };
        } else return { ...item };
    });
    return listDataSizes;
};

const mapAnswersToQuestions = (arrQuestions, arrAnswers) => {
    return arrQuestions.map((question, i) => {
        const mappedAnswer = arrAnswers.find((answer) => question.id === answer.questionId);
        if (mappedAnswer) {
            return Object.assign({
                ...question,
                answerId: mappedAnswer?.id,
                answerUpdated: mappedAnswer?.updated,
                valueAnswer: mappedAnswer?.valueAnswer,
                questionDataIds: mappedAnswer?.questionDataIds,
            });
        } else {
            return { ...question };
        }
    });
};

export interface ISizesQuizProps {
    handleNext?: (value: Boolean, order?: number, gender?: EGENDER) => void;
}

interface IQuestionSlideItem {
    id: string;
    listOptions: Array<{
        title: string;
        isSelect: boolean;
    }>;
    listSecondOptions?: Array<{
        title: string;
        value: string;
        isSelect: boolean;
    }>;
    questionDataSubject: string;
    questionDataIds: Array<string>;
    questionDataSubjectTags: Array<string>;
    valueAnswer: string;
    subTitle: string;
    title: string;
    type: string;
    answerUpdated?: boolean;
    answerId?: string;
    submitted?: boolean;
}

export default function SizesQuiz(props: ISizesQuizProps) {
    const { userName } = useParams<{ userName: string }>();
    const { currentUser } = useAuth();
    const history = useHistory();
    const gender = useGetGender(Boolean(userName));
    const location = useLocation();
    const classes = useStyles();
    const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();
    const [listQuestionSize, setListQuestionSize] = useState<Array<IQuestionSlideItem>>([]);
    const [currentSlideRealIndex, setCurrentSlideRealIndex] = useState(0);
    const [listAnswer, setListAnswer] = useState<any[]>([]);
    const [savedAnswers, setSavedAnswers] = useState<any[]>([]);
    const isConsumerView = () => Boolean(!userName);
    const [quizData, setQuizData] = useState<any>(null);
    const [pendingSaveApi, setPendingSaveApi] = useState(0);
    const [pendingApiLoading, setPendingApiLoading] = useState(false);
    const { handleNext } = props;

    useEffect(() => {
        // Check allow nextSlide
        if (
            location.pathname === PATH.QUIZ_MANAGER &&
            swiperInstance &&
            listQuestionSize.length > 0 &&
            !listQuestionSize[currentSlideRealIndex].submitted
        ) {
            swiperInstance.allowSlideNext = false;
        } else {
            if (swiperInstance) {
                swiperInstance.allowSlideNext = true;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listQuestionSize, swiperInstance, currentSlideRealIndex]);

    //Initial Query
    const [getUserByUserName, { loading: userLoading }] = useLazyQuery(GET_USER_BY_USERNAME, {
        onCompleted(data) {
            if (listQuestionSize.length <= 0) {
                getQuizResponse({
                    variables: {
                        input: {
                            quizId: getSizeQuizId(data.getUserByUserName?.gender),
                            contextType: quizContextType,
                            contextId: getSizeQuizId(data.getUserByUserName?.gender),
                            userId: data.getUserByUserName?.id,
                        },
                    },
                });
            }
        },
    });
    const [getQuestionData, { loading: questionDataLoading }] = useLazyQuery(GET_QUESTION_DATA, {
        onCompleted(data) {
            const listQuestionDatas = data.getQuestionData.data;
            setListQuestionSize(mapQuestionDataToQuestions(listQuestionSize, listQuestionDatas, currentSlideRealIndex));
        },
    });
    const createAnswer = async (input: {
        questionId: String;
        questionSubject: String;
        contextType: String;
        contextId: String;
        value: any;
        valueType: String;
        questionDataIds: string[];
        id?: string;
    }) => {
        const variables = {
            input,
        };
        await answerMutation({ variables });
    };
    const [answerMutation, { loading: createAnswerLoading }] = useMutation(CREATE_ANSWER, {
        onCompleted(data) {
            setListQuestionSize(
                listQuestionSize.map((question, index) => {
                    if (index === currentSlideRealIndex) {
                        return {
                            ...question,
                            submitted: true,
                        };
                    }
                    return question;
                }),
            );
            setPendingSaveApi((prevValue) => prevValue - 1);
            setSavedAnswers([...savedAnswers, { ...data?.createAnswer }]);
        },
        onError(error) {
            console.log('Create Failed: ', error);
        },
    });
    const parseAnswerValue = (questionId, valueAnswer) => {
        if (MultipleColumnQuestion.includes(questionId)) {
            return valueAnswer.split(',');
        } else {
            return valueAnswer;
        }
    };

    const [getQuizResponse, { loading: loadingQuiz }] = useLazyQuery(GET_QUIZ_RESPONSE, {
        fetchPolicy: 'no-cache',
        onCompleted(data) {
            setQuizData(data.getQuizResponse);
            const answers = _.valuesIn(data.getQuizResponse?.answers);
            const listAnswers = answers.map((answer) => {
                return {
                    id: answer.id,
                    questionId: answer.questionId,
                    valueAnswer: parseAnswerValue(answer.questionId, answer.value),
                    questionDataSubject: answer?.questionDatas[0]?.subject,
                };
            });
            setListAnswer(listAnswers);
            const listQuestions = _.valuesIn(data.getQuizResponse?.questions);
            const arrSizeOptions: any[] = listQuestions.map((item) => {
                return {
                    id: item.id,
                    questionId: item.id,
                    listOptions: [],
                    questionDataSubject: item.questionDataSubject,
                    questionDataSubjectTags: item.questionDataSubjectTags,
                    subTitle: item.subTitle,
                    title: item.title,
                    type: item.type,
                };
            });
            setListQuestionSize(mapAnswersToQuestions(arrSizeOptions, listAnswers));
            getQuestionData({
                variables: {
                    input: {
                        subject: listQuestions[0].questionDataSubject,
                        tags: listQuestions[0].questionDataSubjectTags,
                        paging: { page: 0, size: 0 },
                        enabled: true,
                    },
                },
            });
        },
    });

    useEffect(() => {
        if (userName) {
            getUserByUserName({
                variables: {
                    input: {
                        userName,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userName]);
    useEffect(() => {
        if (currentUser && isConsumerView() && gender && listQuestionSize.length <= 0) {
            getQuizResponse({
                variables: {
                    input: {
                        quizId: getSizeQuizId(gender),
                        contextType: quizContextType,
                        contextId: getSizeQuizId(gender),
                        userId: currentUser.uid,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gender]);

    // Function
    const handleChangeSlide = (e) => {
        setCurrentSlideRealIndex(e.realIndex);
        if (listQuestionSize[e.realIndex]) {
            getQuestionData({
                variables: {
                    input: {
                        subject: listQuestionSize[e.realIndex]?.questionDataSubject,
                        tags: listQuestionSize[e.realIndex]?.questionDataSubjectTags,
                        paging: { page: 0, size: 0 },
                        enabled: true,
                    },
                },
            });
        }
    };

    const handleSelectSize = async (slide, itemSelect) => {
        const input: any = {
            questionId: slide.questionId,
            questionSubject: slide.questionDataSubject,
            contextType: quizContextType,
            contextId: getSizeQuizId(gender),
            value: itemSelect.value,
            valueType: 'STRING',
            questionDataIds: [itemSelect.id],
        };
        if (slide.answerId) {
            input.id = slide.answerId;
        }
        updateListAnswerData(input, true);
    };

    const handleSelectMultipleOptionsQuestion = async (slide, selectedItems) => {
        let questionDataArr = [slide.listOptions, slide.listSecondOptions];
        const selectedQuestionData = selectedItems?.map((item, index) => {
            if (item.id) {
                return item;
            } else if (item.value) {
                return questionDataArr[index]?.find((data) => data.value === item.value);
            }
            return item;
        });
        const input: any = {
            questionId: slide.questionId,
            questionSubject: slide.questionDataSubject,
            contextType: quizContextType,
            contextId: getSizeQuizId(gender),
            value: selectedQuestionData.map((item) => item.value),
            valueType: 'STRING',
            questionDataIds: selectedQuestionData.map((item) => item.id),
        };
        if (slide.answerId) {
            input.id = slide.answerId;
        }
        updateListAnswerData(
            input,
            selectedQuestionData.every((item) => item && item.value && item.id),
        );
    };

    const updateListAnswerData = (updatedAnswer, updated: boolean) => {
        const updatedAnswerIndex = listAnswer.findIndex((answer) => answer.questionId === updatedAnswer.questionId);
        // Update
        if (updatedAnswerIndex >= 0) {
            listAnswer[updatedAnswerIndex] = { ...updatedAnswer, valueAnswer: updatedAnswer.value, updated };
        }
        // Add new
        else {
            listAnswer.push({ ...updatedAnswer, valueAnswer: updatedAnswer.value, updated });
        }
        setListAnswer(listAnswer);
        setListQuestionSize(mapAnswersToQuestions(listQuestionSize, listAnswer));
    };

    const submitAnswer = async (answer) => {
        if (isConsumerView() && answer) {
            setPendingSaveApi((prevValue) => prevValue + 1);
            await createAnswer(answer);
        }
    };

    const processNextQuiz = async () => {
        if (swiperInstance) {
            try {
                const currentQuestion = listQuestionSize[currentSlideRealIndex];
                let answerId = currentQuestion?.answerId;
                if (!answerId) {
                    answerId = savedAnswers.find((item) => item?.questionId === currentQuestion.id)?.id;
                }
                const answer = {
                    questionId: currentQuestion.id,
                    questionSubject: currentQuestion.questionDataSubject,
                    contextType: quizContextType,
                    contextId: getSizeQuizId(gender),
                    value: Array.isArray(currentQuestion.valueAnswer)
                        ? currentQuestion.valueAnswer.join(',')
                        : currentQuestion.valueAnswer,
                    valueType: 'STRING',
                    questionDataIds: currentQuestion.questionDataIds,
                    id: answerId,
                };
                submitAnswer(answer);
            } catch (error) {
                console.debug(error);
            }
        }

        // NOT LAST QUESTION
        if (currentSlideRealIndex < listQuestionSize.length - 1) {
            swiperInstance?.slideNext();
        }
        // LAST QUESTION
        else {
            if (location.pathname === PATH.SIZES_QUIZ) {
                history.push(PATH.PROFILE);
                return;
            }

            setPendingApiLoading(true);
            return;
        }
    };

    const handleNextClick = useCallback(() => {
        if (handleNext) {
            handleNext(false, EQuizOrder.SIZES, gender === EGENDER.MALE ? EGENDER.MALE : EGENDER.FEMALE);
        } else if (location.pathname !== PATH.QUIZ_MANAGER) {
            setPendingApiLoading(false);
        }
    }, [handleNext, gender, location.pathname]);

    useEffect(() => {
        if (pendingApiLoading && !pendingSaveApi) {
            handleNextClick();
        }
    }, [pendingApiLoading, pendingSaveApi, handleNextClick]);

    useEffect(() => {
        if (
            listQuestionSize?.length &&
            location.pathname === PATH.SIZES_QUIZ &&
            currentSlideRealIndex === listQuestionSize.length - 1
        ) {
            // setShowDoneButton(true);
        } else {
            // setShowDoneButton(false);
        }
    }, [currentSlideRealIndex, listQuestionSize, location, location.pathname]);

    const SubmitButton = (props: { index; active }) => {
        return (
            <button
                type="submit"
                key={props.index}
                className={classes.button}
                style={{
                    color: themes.palette.common.white,
                    backgroundColor: props.active ? themes.palette.primary.main : '#A3A3A3',
                }}
                onClick={() => {
                    if (swiperInstance) {
                        swiperInstance.allowSlideNext = true;
                        processNextQuiz();
                    }
                }}
                disabled={!props.active}
            >
                {location.pathname !== PATH.QUIZ_MANAGER ? STRINGS.UPDATE : STRINGS.SAVE}{' '}
                {pendingApiLoading && <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />}
            </button>
        );
    };

    const renderSingleSelectItem = (slide, index) => {
        if (slide.listOptions.length > 0) {
            if (MultipleColumnQuestion.includes(slide.id)) {
                return (
                    <Box className={classes.styleContainer}>
                        <MultipleiOSPicker
                            optionGroups={{
                                firstColumnOptions: slide.listOptions,
                                secondColumnOptions: slide.listSecondOptions,
                            }}
                            valueGroup={{
                                firstColumnValue: slide.valueAnswer ? slide.valueAnswer[0] : undefined,
                                secondColumnValue: slide.valueAnswer ? slide.valueAnswer[1] : undefined,
                            }}
                            onChange={(selectedOptions) => {
                                handleSelectMultipleOptionsQuestion(slide, selectedOptions);
                            }}
                        />
                    </Box>
                );
            }

            return (
                <Box className={classes.styleContainer}>
                    <Picker
                        optionGroups={{
                            name: slide.listOptions,
                        }}
                        valueGroups={{
                            name: slide.valueAnswer,
                        }}
                        onChange={(name, value, selectedOption) => {
                            if (isConsumerView() && value)
                                handleSelectSize(slide, { value: value, id: selectedOption.id });
                            else return;
                        }}
                    />
                </Box>
            );
        }

        if (questionDataLoading) {
            return (
                <div className={`${classes.flexCenter} ${classes.pickerContainer} picker-container`}>
                    <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                </div>
            );
        }

        return <div className={`${classes.flexCenter} ${classes.pickerContainer} picker-container`}></div>;
    };

    return (
        <CustomizeLayoutQuiz
            quizId={getSizeQuizId(gender)}
            title={Boolean(!userName) ? quizData?.subTitle : ''}
            titlePage={quizData?.title}
            handleAnswer={processNextQuiz}
            isUpdate={location.pathname.includes(PATH.MY_STYLE_PREFERENCES)}
            isDisplayContent={isConsumerView()}
            hideBottomNav={location.pathname === PATH.QUIZ_MANAGER}
            requiredQuestion
            isHiddenAction={true}
            loading={createAnswerLoading}
            containerLoading={loadingQuiz || userLoading}
        >
            <Box
                textAlign={'center'}
                display="flex"
                flexDirection="column"
                width={'100%'}
                height={'100%'}
                id="swiper-wrapper"
                position={'relative'}
            >
                <Box
                    display={'flex'}
                    flexDirection={'column'}
                    textAlign={'center'}
                    width={'100%'}
                    height={`100%`}
                    pt={2}
                >
                    <Swiper
                        direction="horizontal"
                        onSlideChange={handleChangeSlide}
                        onSwiper={setSwiperInstance}
                        slidesPerView={1.2}
                        centeredSlides={true}
                        spaceBetween={10}
                        className={classes.fitContent}
                        mousewheel
                    >
                        {listQuestionSize?.map((slide, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <Box className={classes.sizesWrapper}>
                                        <Box padding={'0 0 18px 0'} marginTop={'auto'}>
                                            <TitlePage size={24}>{(slide.title as string).toUpperCase()}</TitlePage>
                                        </Box>
                                        <Box
                                            position={'relative'}
                                            maxHeight="316px"
                                            width={'100%'}
                                            bgcolor={'white'}
                                            borderRadius={'20px'}
                                            display="flex"
                                            flexDirection={'column'}
                                            marginBottom={'auto'}
                                        >
                                            {renderSingleSelectItem(slide, index)}
                                        </Box>
                                        {currentSlideRealIndex === index ? (
                                            <SubmitButton
                                                index={index}
                                                active={
                                                    listQuestionSize[currentSlideRealIndex].answerUpdated &&
                                                    !pendingApiLoading
                                                }
                                            />
                                        ) : (
                                            <div style={{ height: 44, marginBottom: 12 }}></div>
                                        )}
                                    </Box>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </Box>
            </Box>
        </CustomizeLayoutQuiz>
    );
}
